import { setScrolled } from './../../helpers/events';

export default () => {

	const collectionHeader = document.querySelector('.collection-header');
	if (!collectionHeader) return;

	setScrolled(() => {

		if (window.pageYOffset > 100) {
			collectionHeader.classList.add('scrolled');
		}
		else {
			collectionHeader.classList.remove('scrolled');
		}

	})

}